var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"aside-line aside-line-lt"}),_c('div',{staticClass:"aside-line aside-line-rt"}),_c('div',{staticClass:"aside-line aside-line-rb"}),_c('div',{staticClass:"aside-line aside-line-lb"})])
}]
render._withStripped = true
export { render, staticRenderFns }